export function isFunction(value: any): boolean {
  return 'function' == typeof value;
}
